import type { HttpClient } from '../../../types/api';
import type { GetTermConsentPendingResponse } from '../types';

/**
 * 同意が必要な規約（再承諾）を取得する。
 * 要再承諾版がない、または全て同意済みなら categories / documents とも空で返る。
 */
export const getTermConsentPending = async (httpClient: HttpClient): Promise<GetTermConsentPendingResponse> => {
  return await httpClient.get<GetTermConsentPendingResponse>('/user/v1/term-consent/pending');
};
